export class Classification {
	id: number;
	classification: string;
	description: string;
	offer_footer_text: string;
	user_created: string;
	user_modified: string;
	created_at: string;
	updated_at: string;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/crm/classification.ts